// Owner-approved starting prices for tailored ODIN engagements (23 October 2026).
// Scope examples describe the original service distinctions, not volume guarantees.
const plans = [
  {
    name: "Pilot+",
    price: "From £2,900 / month",
    description:
      "A focused starting point to evaluate quality, workflow and value before scaling.",
    features: [
      "Managed setup and onboarding",
      "Quality review framework",
      "Performance baseline and review priorities",
    ],
    button: "Discuss your project",
    featured: false,
  },
  {
    name: "Launch",
    price: "From £4,900",
    description:
      "For a coordinated launch with managed content delivery and production support.",
    features: [
      "Project setup and production operations",
      "Content quality control",
      "Executive reporting within the agreed scope",
    ],
    button: "Discuss your project",
    featured: false,
  },
  {
    name: "Growth",
    price: "From £14,900",
    description:
      "For larger multi-site programmes that need dedicated delivery oversight.",
    features: [
      "Dedicated delivery oversight",
      "Priority production planning",
      "Governance and scale operations",
    ],
    button: "Discuss your project",
    featured: true,
  },
  {
    name: "Custom",
    price: "Get a tailored quote",
    description:
      "An individual implementation for your workflow, requirements and scale.",
    features: [
      "Can start with a single site or page",
      "One-off or ongoing services, as agreed",
      "Tailored model, quality and rollout requirements",
    ],
    button: "Get a tailored quote",
    featured: false,
  },
];
module.exports = { plans };
